import Avatar from "@/components/common/Avatar";
import StarIcon from "@/assets/icons/web_Icons/star.svg";
import TrashIcon from "@/assets/icons/web_Icons/trash.svg";
import SendIcon from "@/assets/icons/web_Icons/send.svg";

const SingleNotification = () => {
  return (
    <div className="pb-6 text-left">
      {/* Header */}
      <div className="flex items-center justify-between p-4 border-b">
        <button className="font-semibold">&lt; BACK</button>
        <button className="font-semibold">NEXT &gt;</button>
      </div>

      {/* Sender Info */}
      <div className="flex items-center justify-between p-4 border-b">
        <div className="flex items-center gap-2">
          <Avatar size={40} alt="Nusaiba Sabiu" />
          <div>
            <p className="text-lg font-bold">Nusaiba Sabiu</p>
            <p className="text-sm text-gray-500">to me • 30 Min ago</p>
          </div>
        </div>

        {/* Email Actions */}
        <div className="flex items-center gap-4">
          <button className="flex items-center gap-1 text-gray-500 hover:text-yellow-500">
            <span>Star</span>
            <img src={StarIcon} alt="Star Icon" />
          </button>
          <button className="flex items-center gap-1 text-gray-500 hover:text-red-500">
            <span>Trash</span>
            <img src={TrashIcon} alt="Trash Icon" />
          </button>
        </div>
      </div>

      {/* Email Body */}
      <div className="p-2 text-base sm:p-6">
        <p className="mb-2 text-gray-900">Dear Aille,</p>
        <p className="mb-4 ">
          Thank you for reaching out to us regarding your payment options. We
          understand that you wanted to ensure that your default payment option
          could not be switched to another card.
        </p>
        <p className="mb-4 ">
          We apologize for any inconvenience this may have caused. We are
          pleased to inform you that our team has investigated the issue and
          found a solution to your problem.
        </p>
        <p className="mb-4 ">
          You can now rest assured that your default payment option cannot be
          switched to another card without your explicit consent.
        </p>
        <p className="mb-4 ">
          We value your business and appreciate your feedback. If you have any
          further questions or concerns, please don&apos;t hesitate to reach out
          to us.
        </p>
        <p className="">We are always happy to assist you.</p>
        <p className="mb-4 ">Thank you for choosing our service.</p>

        {/* Signature */}
        <p className="">Best regards,</p>
        <p className="font-bold">Nusaiba Sabiu</p>
        <p className="">Customer Support Team</p>
      </div>

      {/* Message Input */}
      <div className="flex items-center w-full border p-2 border-t rounded-lg bg-[#F0F4F9]">
        <input
          type="text"
          placeholder="Type your message..."
          className="w-full bg-[#F0F4F9] focus:outline-none focus:ring-0 p-2"
        />
        <img src={SendIcon} alt="Send Icon" />
      </div>
    </div>
  );
};

export default SingleNotification;
